import React from 'react';
import { IonCardTitle, IonCardContent, IonChip } from '@ionic/react';

type Props = {
  data: [],
  title: string,
};

const Activities: React.FC<Props> = ({ data, title }) => {
  if (!data || data.length === 0) {
    return (<></>);
  }
  return (
    <div>
      <IonCardContent>
        <IonCardTitle>{title}</IonCardTitle>
        { data.map((item: any, index: number) => {
            return (
              <IonChip key={'activities-' + index}>{item.name}</IonChip>
            );
          })
        }
      </IonCardContent>
    </div>
  )
  
};

export default Activities;